(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-utilities"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pm-footer-links')) {
    customElements.define('pm-footer-links', class extends HTMLElement {
      connectedCallback() {
        this.alignLinks = () => {
          if (!this.isConnected) return;
          const offerReference = document.getElementById('pm-parcours-intro');
          if (offerReference) {
            const offerWidth = offerReference.getBoundingClientRect().width;
            if (offerWidth > 0) document.body.style.setProperty('--pm-home-offer-width', offerWidth + 'px');
          }
          const reference = document.querySelector('[class*="text_yq98zX"] p');
          if (!reference || !reference.textContent.trim()) return;
          const range = document.createRange();
          range.selectNodeContents(reference);
          const width = Math.min(range.getBoundingClientRect().width, this.parentElement.clientWidth);
          if (width > 0) this.style.setProperty('--pm-legal-line-width', width + 'px');
        };
        this.resizeObserver = new ResizeObserver(this.alignLinks);
        const offerReference = document.getElementById('pm-parcours-intro');
        if (offerReference) this.resizeObserver.observe(offerReference);
        const reference = document.querySelector('[class*="text_yq98zX"]');
        if (reference) this.resizeObserver.observe(reference);
        if (this.parentElement) this.resizeObserver.observe(this.parentElement);
        this.alignLinks();
        document.fonts.ready.then(this.alignLinks);
      }
      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
